/**
 * @file Общий счётчик загрузки и скачивания.
 *
 * Получает подтверждённые значения через props. Ограничение percent не даёт
 * анимации показать завершение раньше самой передачи; CSS удерживает ширину полей.
 */
import { useLocale } from '../../i18n/useLocale'
import { formatTrafficBytes } from '../traffic/quota'
import { useSmoothNumber } from './useSmoothNumber'

export default function TransferProgress({
    id,
    name,
    bytes,
    total,
    percent,
    active,
}: {
    id: string
    name: string
    bytes: number
    total: number | null
    percent: number
    active: boolean
}) {
    const { locale } = useLocale()
    const displayed = useSmoothNumber(bytes, id, active)
    const displayedPercent =
        active && total
            ? Math.min(percent, Math.floor((displayed / total) * 100))
            : percent

    function size(value: number) {
        const formatted = formatTrafficBytes(value, locale)

        return `${formatted.value} ${formatted.unit}`
    }

    return (
        <>
            <progress
                className='upload-progress'
                max={100}
                value={displayedPercent}
                aria-label={name}
            />

            <p className='upload-count'>
                <span className='transfer-percent'>{displayedPercent}%</span>
                <span aria-hidden='true'>·</span>
                <span className='transfer-bytes'>{size(displayed)}</span>
                {total !== null && (
                    <>
                        <span aria-hidden='true'>/</span>
                        <span className='transfer-bytes'>{size(total)}</span>
                    </>
                )}
            </p>
        </>
    )
}
